export const ClipWidth = 49 // make a better connection to the css variables and adjustable